var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSmoking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uxszzvx7ra)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.62 45.946c0 21.315-17.279 38.594-38.594 38.594S6.432 67.261 6.432 45.946 23.71 7.352 45.026 7.352 83.621 24.63 83.621 45.946z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.624 48.464c0 19.925-16.153 36.078-36.078 36.078-19.925 0-36.077-16.153-36.077-36.078 0-19.925 16.152-36.077 36.077-36.077 19.925 0 36.078 16.152 36.078 36.077z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.688 42.324c1.93-4.582-.362-12.66-5.305-14.71 0 0-1.688-11.212-11.212-11.212-9.525 0-10.248 11.213-4.22 14.106 0 0 2.17 6.27 9.645 6.27 7.476 0 7.475 5.546 7.475 5.546l1.587 1.587 2.03-1.587z",
    fill: "#65687F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.568 42.324h51.12v12.298h-51.12V42.324z",
    fill: "#D8EDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.568 49.559h51.12v5.063h-51.12V49.56z",
    fill: "#A8C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.14 42.324h5.546v12.298h-5.545V42.324z",
    fill: "#FF5A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.14 49.559h5.546v5.063h-5.545V49.56z",
    fill: "#D4243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.568 42.324h13.986v12.298H18.568V42.324z",
    fill: "#F2B375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.568 49.559h13.986v5.063H18.568V49.56z",
    fill: "#E09544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.333 0C20.296 0 0 20.296 0 45.333c0 25.038 20.296 45.334 45.333 45.334 25.038 0 45.334-20.296 45.334-45.334C90.667 20.296 70.37 0 45.333 0zM8.154 45.333c0-12.6 6.27-23.734 15.858-30.459l35.49 64.84a37.063 37.063 0 0 1-14.169 2.798c-20.533 0-37.179-16.645-37.179-37.179zm58.5 30.46-35.49-64.84a37.065 37.065 0 0 1 14.17-2.799c20.533 0 37.176 16.646 37.176 37.18 0 12.6-6.269 23.735-15.857 30.46z",
    fill: "#FF4545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uxszzvx7ra"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h90.667v90.667H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSmoking);
export default __webpack_public_path__ + "static/media/no-smoking.da6cbac6a1dddfdbc13de7b2124180e2.svg";
export { ForwardRef as ReactComponent };